module.exports = __webpack_public_path__ + "img/zhipinban6.b867997e.jpg";